import React from 'react';
import { useFilters } from '../../cube/filters';

function Chip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: '#e2e8f0', color: '#0f172a',
      borderRadius: 999, padding: '4px 8px', marginRight: 8, marginBottom: 8,
      fontSize: 12, fontWeight: 500
    }}>
      {label}
      <button onClick={onRemove} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>×</button>
    </span>
  );
}

export const ActiveFilterChips: React.FC = () => {
  const { filters, set } = useFilters();

  const chips: Array<{ key: string; label: string; remove: () => void }> = [];

  if (filters.bairros?.length) {
    for (const b of filters.bairros) {
      chips.push({ key: `bairro:${b}`, label: `Bairro: ${b}`, remove: () => set({ bairros: (filters.bairros || []).filter(x => x !== b) || undefined }) });
    }
  }
  if (filters.h3?.length) {
    for (const h of filters.h3) {
      chips.push({ key: `h3:${h}`, label: `H3: ${h.slice(-6)}`, remove: () => set({ h3: (filters.h3 || []).filter(x => x !== h) || undefined }) });
    }
  }
  if (filters.unitTypes?.length) {
    for (const t of filters.unitTypes) {
      chips.push({ key: `type:${t}`, label: `Tipo: ${t}`, remove: () => set({ unitTypes: (filters.unitTypes || []).filter(x => x !== t) || undefined }) });
    }
  }
  if (filters.bedrooms?.length) {
    for (const n of filters.bedrooms) {
      chips.push({ key: `bed:${n}`, label: `Quartos: ${n}`, remove: () => set({ bedrooms: (filters.bedrooms || []).filter(x => x !== n) || undefined }) });
    }
  }
  if (filters.bathrooms?.length) {
    for (const n of filters.bathrooms) {
      chips.push({ key: `bath:${n}`, label: `Banheiros: ${n}`, remove: () => set({ bathrooms: (filters.bathrooms || []).filter(x => x !== n) || undefined }) });
    }
  }
  if (filters.parking?.length) {
    for (const n of filters.parking) {
      chips.push({ key: `park:${n}`, label: `Vagas: ${n}`, remove: () => set({ parking: (filters.parking || []).filter(x => x !== n) || undefined }) });
    }
  }

  if (!chips.length) return null;

  return (
    <div style={{ marginTop: 8 }}>
      {chips.map(c => <Chip key={c.key} label={c.label} onRemove={c.remove} />)}
    </div>
  );
};


